import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../css/ProductDetails.css'; // <-- CSS File Import
import { API_BASE } from '../config';

export default function ProductDetails() {
  const { productId } = useParams();
  const navigate = useNavigate();

  // States
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImage, setActiveImage] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState('');

  // Helper function to parse images safely
  const parseImages = (imgData) => {
    if (!imgData) return ['placeholder.jpg'];
    if (Array.isArray(imgData)) return imgData;
    try {
      const parsed = JSON.parse(imgData);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {
      if (typeof imgData === 'string' && imgData.includes(',')) {
        return imgData.split(',').map(img => img.trim());
      }
    }
    return [String(imgData).trim()];
  };

  useEffect(() => {
    if (!productId) return;
    setLoading(true);
    
    fetch(`${API_BASE}/api/products/${productId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.data) {
          const prod = data.data;
          setProduct(prod);
          
          const imgList = parseImages(prod.images || prod.Images);
          if (imgList.length > 0) {
            setActiveImage(imgList[0]);
          }
          
          setQuantity(prod.moq || 1);
        } else {
          setProduct(null);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Detail load failure:", err);
        setProduct(null);
        setLoading(false);
      });
  }, [productId]);

  const handleIncrement = () => {
    if (quantity < (product?.stock || 9999)) {
      setQuantity(prev => prev + 1);
    } else {
      alert("Aap isse zyada stock select nahi kar sakte!");
    }
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  const handleAddToCart = () => {
    const currentCart = JSON.parse(localStorage.getItem('user_cart')) || [];
    const isExist = currentCart.find(item => item.id === product.id);

    if (!isExist) {
      const cartItem = { ...product, quantity: quantity, selectedColor };
      currentCart.push(cartItem);
      localStorage.setItem('user_cart', JSON.stringify(currentCart));
      alert(`${product.title || product.Title} aapke cart mein jod diya gaya hai!`);
    } else {
      alert("Yeh product pehle se hi aapke cart mein hai!");
    }
  };

  if (loading) return <h3 style={{ textAlign: 'center', padding: '100px' }}>Loading Product Details...</h3>;
  if (!product) return <h3 style={{ textAlign: 'center', padding: '100px' }}>Product Not Found!</h3>;

  const productImages = parseImages(product.images || product.Images);

  return (
    <div className="product-details-wrapper">
      <div className="product-details-grid">
        
        {/* Gallery Block */}
        <div className="gallery-container">
          <div className="thumbnail-list">
            {productImages.map((imgUrl, index) => (
              <div 
                key={index} 
                onClick={() => setActiveImage(imgUrl)}
                className={`thumb-item ${activeImage === imgUrl ? 'active-thumb' : ''}`}
              >
                <img src={imgUrl} alt="thumb" />
              </div>
            ))}
          </div>

          <div className="main-image-display">
            <img src={activeImage || 'placeholder.jpg'} alt={product.title || product.Title} />
          </div>
        </div>

        {/* Metadata Column */}
        <div className="metadata-column">
          <div className="delivery-badge-box">
            <span>Fast delivery within 72 Hours</span>
            <span className="dhl-text">DHL</span>
          </div>

          <h1 className="product-title-heading">{product.title || product.Title}</h1>
          <div className="product-price-display">
            ₹{product.price || product.Price}.00
          </div>

          <p className="product-description-text">
            {product.description || product.Description || "Premium quality B2B marketplace inventory item."}
          </p>

          <div className="actions-row-container">
            <div className="quantity-stepper-box">
              <button onClick={handleDecrement}>-</button>
              <input type="text" value={quantity} readOnly className="quantity-input-field" />
              <button onClick={handleIncrement}>+</button>
            </div>

            <button onClick={handleAddToCart} className="btn-add-to-cart">
              Add To Cart
            </button>
            
            <button 
              onClick={() => navigate("/checkout", { state: { product, quantity } })} 
              className="btn-buy-now"
            >
              Buy Now
            </button>
          </div>
        </div>

        {/* Policies Column */}
        <div className="policies-column">
          <div className="policy-card-box">
            <h3 className="policy-card-title">Shipping & Delivery</h3>
            <div className="policy-info-row">
              <span>📦</span>
              <div className="policy-info-content">
                <h4>Standard Delivery</h4>
                <p>Courier delivery to warehouse</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}